import BaseComponent from '../App/base';
//import * as actions from '../../actions/MessagesActions';
import './index.scss'

export default class PostActionMessages extends BaseComponent {
  constructor(selector, store) {
    super(selector, store, 'messages');

    /* Temporary fallback - for the usage with ongoing app refactoring */
    window.messagesActions = actions;

    this.$pamArea = $('#pam-area');

    this.msg = {
      done: 'completed',
      move: 'moved to ',
      edit: 'edited to ',
      copy: 'copied to clipboard',
      delete: 'deleted',
      undo: 'uncompleted',
    };

    autobind(this);
  }

  static getDestDate(date) {
    return $(`.column[rel=${date}] h1`)
      .text()
      .trim()
      .replace('\n', ', ')
      .replace(/[\t]/g, '');
  }

  static getTodayDate(today) {
    return moment(today).format('ddd, D');
  }

  prepareData(taskId, text, op, parameters) {
    console.log(this);
    this.pamId = `pam-${
      Math.random()
        .toString()
        .substr(2)}`;

    this.taskId = taskId;

    const data = {
      date: '',
      txt: '',
      css: '',
      additional: '',
      op,
    };

    console.log(this);

    switch (op) {
      case 'move':
        data.date = PostActionMessages.getDestDate(parameters.destDate);
        break;

      case 'undo':
        if (parameters.date !== parameters.today) {
          data.date = ` and moved to ${PostActionMessages.getTodayDate(parameters.today)}`;
        }
        break;

      case 'edit':
        data.txt = escapeHtml(parameters.preEdit);
        data.css = 'txt-s';
        data.additional = text;
        break;

      default:
        data.txt = escapeHtml(text);
        data.css = 'txt';
    }

    return data;
  }

  handleDone(parameters) {
    const self = this;

    console.log(`${self.taskId} + ${parameters.day} + ${parameters.order}`);
    undoTask(self.taskId, parameters.day, parameters.order);
    $(`#${self.pamId}`).remove();
  }

  handleDelete() {
    const self = this;
    restoreTask(self.taskId);
    $(`#${self.pamId}`).remove();
  }

  handleEdit(parameters) {
    const self = this;

    editTask(self.taskId, parameters.preEdit, '');
    $(`#${self.taskId}`).attr('data-text-full', parameters.preEdit);
    $(`#${self.taskId}`)
      .find('mark')
      .html(shortenUrls(parameters.preEdit));
    $(`#${self.pamId}`).remove();
  }

  handleMove(parameters) {
    const self = this;

    updateTask(self.taskId, parameters.srcDate, parameters.ind);
    if ($(`.column[rel=${parameters.destDate}]`)) {
      if ($(`.column[rel=${parameters.srcDate}]`)) {
        if (parameters.ind > 1) {
          $(`#${self.taskId}`).insertAfter(
            $('.todo li', $(`.column[rel=${parameters.srcDate}]`))[
              parameters.ind - 2
            ],
          );
        } else {
          $(`#${self.taskId}`).prependTo(
            $('.todo', $(`.column[rel=${parameters.srcDate}]`)),
          );
        }
        $('<span class="addBefore"></span>').insertBefore(`#${self.taskId}`);
      } else {
        $(`#${self.taskId}`).remove();
      }
    } else if ($(`.column[rel=${parameters.srcDate}]`)) {
      ajax('get', { id: self.taskId }, (data) => {
        html = makeTaskHtml(data);
        if (parameters.ind > 1) {
          $(html).insertAfter(
            $('.todo li', $(`.column[rel=${parameters.srcDate}]`))[
              parameters.ind - 2
            ],
          );
        } else {
          $(html).prependTo(
            $('.todo', $(`.column[rel=${parameters.srcDate}]`)),
          );
        }
        assign();
      });
    }
    $(`#${self.pamId}`).remove();
    updateBoxIcon();
  }

  static handleCopy() {}

  handleUndo(parameters) {
    const self = this;

    redoTask(self.taskId, parameters.date, parameters.order);
    $(`#${self.pamId}`).remove();
  }

  render() {
    const self = this;
    const {
      taskId, txt, op, parameters,
    } = this.state.messages;
    const data = this.prepareData(taskId, txt, op, parameters);
    const handler = this[`handle${op.charAt(0).toUpperCase()}${op.slice(1)}`];

    const undo = op === 'copy' ? '' : '<a class="undo">Undo?</a>';

    const message = `<div id="${self.pamId}">
            <span class="${data.css}">${data.txt}</span> 
            <span class="msg">${this.msg[data.op]}${data.date}</span> 
            <span class="txt-s">${data.additional}</span>
            ${undo}
            </div>`;

    this.$pamArea.html('').append(message);

    const item = self.pamId;
    setTimeout(() => {
      console.log('remove');
      $(`#${item}`).remove();
    }, 5000);

    this.$pamArea.find('.undo').click(() => {
      handler(parameters);
    });
  }
}
